<template>
<div>
  <el-button style="width:100%;" type="secondary" size="small" @click="open">연결 장비 분석</el-button>
  <w-sliding-popup ref="slidingPopup" title="연결 장비 리스트" top="50px" width="400px" @close="close">
    <div slot="content">
      <div class="title-h4 title-bar">서비스 목록</div>
      <el-table-wrapper class="mr-b25" :columns="serviceTableColumns" :column-default="columnDefault" :data="serviceTableData" ref="serviceTable" row-class-name="c-pointer" @row-click="clickServiceRow" :pagination="false" header-align="center" highlight-current-row>
      </el-table-wrapper>
      <div class="title-h4 title-bar">{{deviceListTitle}}</div>
      <el-table-wrapper :columns="deviceTableColumns" :data="deviceTableData" :pagination="false" header-align="center">
        <template slot-scope="scope" slot="click-item-slot">
            <a href="#" @click="clickItem(scope.row)" class="link">{{scope.row.name}}</a>
          </template>
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import commonAPI from '@/api/performance/common';
import { columnDefault } from '@/constants/table';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import { routePathByObjId } from '@/utils/router';

export default {
  name: 'WDatabaseConnectedDeviceAnalysisButton',
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      deviceListTitle: '장비 목록',
      serviceTableData: [],
      columnDefault,
      serviceTableColumns: [
        {
          prop: 'serviceName',
          label: '서비스 명',
        },
        {
          prop: 'count',
          label: '장비 수',
        },
      ],
      deviceTableData: [],
      deviceTableColumns: [
        {
          prop: 'type',
          label: '타입',
        },
        {
          prop: 'name',
          label: '이름',
          scopedSlot: 'click-item-slot',
        },
      ],
    };
  },
  watch: {
    selectedDeviceRow(row) {
      if (!isNil(row)) {
        this.saveButtonDisableFlag = false;
      } else {
        this.saveButtonDisableFlag = true;
      }
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    loadData() {
      const params = {
        elementId: this.objInfo.obj.objId,
      };
      commonAPI.getServiceListByElementId(params).then((response) => {
        if (response.data.success === true) {
          this.serviceTableData = response.data.data;
          this.$nextTick(() => {
            if (!isNil(response.data.data)) {
              this.$refs.serviceTable.$children[0].setCurrentRow(response.data.data[0]);
              this.clickServiceRow(response.data.data[0]);
            }
          });
        }
      });
    },
    clickServiceRow(row) {
      if (!isNil(row)) {
        this.deviceListTitle = `[${row.serviceName}] 장비 목록`;
        const params = {
          serviceId: row.serviceId,
        };
        commonAPI.getDeviceListByServiceId(params).then((response) => {
          this.deviceTableData = response.data.data;
        });
      }
    },
    clickItem(row) {
      // TODO: objdefine.js를 사용해야하나 현재 'E2E'로되어있어 미사용. 추후 E2E_SERVCIE로 수정 후 objdefine.js 상수 참조하도록 수정 필요
      const objId = row.element_type === 'E2E_SERVICE' ? row.objId.split('.')[1] : row.objId;
      if (!isNil(objId)) {
        routePathByObjId(this, objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name).then(() => {
          this.$emit('change-page');
          this.close();
        });
      }
    },
    close() {
      this.deviceTableData = null;
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/DatabaseConnectedDeviceAnalysisButton.vue